import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-premios',
  templateUrl: './premios.component.html',
  styleUrls: ['./premios.component.scss']
})
export class PremiosComponent implements OnInit {
  @Output() public game: EventEmitter<any> = new EventEmitter;
  @Output() public home: EventEmitter<any> = new EventEmitter;
  constructor() { }

  ngOnInit() {
  }

  goToHome(){
    this.home.emit(true);
  }

  goToGame(){
    this.game.emit(true);
  }

}
